import { Root } from '@radix-ui/react-visually-hidden';

/**
 * Words for a screen reader only (a label a button's icon can't say): Radix VisuallyHidden,
 * in place of hand-written `sr-only` spans. A span by default; `asChild` to hide your own.
 */
export const VisuallyHidden = Root;
